<template>
    <div class="CShareTwitter">
        <CButton
            class="w-full"
            icon="twitter"
            label-class="sm:hidden"
            variant="twitter"
            @click="twitterLink(url, title)"
        >
            Twitter
        </CButton>
    </div>
</template>

<script setup lang="ts">
import { useSharing } from '@/composables/sharing/useSharing'

interface Props {
    url?: string
    title?: string
}

withDefaults(defineProps<Props>(), {
    url: '',
    title: 'Check this out!'
})

const { objectToGetParams } = useSharing()

const twitterLink = (url: string, title: string) => {
    window.open(
        'https://x.com/intent/post' +
            objectToGetParams({
                url,
                text: title
            }),
        '__blank'
    )
}
</script>
